export const Types = {
    SAVE_EASI_HEAD_SCORE: "SAVE_EASI_HEAD_SCORE",
    GET_EASI_TOTAL:"GET_EASI_TOTAL",
    GET_GLOBAL_ASSESSMENT:"GET_GLOBAL_ASSESSMENT",
    SAVE_GLOBAL_ASSESSMENT:"SAVE_GLOBAL_ASSESSMENT",
    PASI_SCORE_NIH: "PASI_SCORE_NIH",
    FLARE_EAS_PASI_SCORES: "FLARE_EAS_PASI_SCORES",
    FLARE_EASI_SCORE: "FLARE_EASI_SCORE",
  };